var moment = require('moment');

const convert = {
  date,
  dateTime,
  upperCaseFirstLetter,
  snakeToCamelCase,
  snakeToSpasiUpperCase,
  spasiToSnakeCase,
  spasiToCamelCase,
  changeDecimalSeparator,
  camelToSpaceUpperCase
};

function date(date){
  const convert = moment(date).format('DD/MM/YYYY');
  return convert;
}

function dateTime(date){
  const convert = moment(date).format('DD/MM/YYYY hh:mm:ss A');
  return convert;
}

function upperCaseFirstLetter(str){
  return str.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function snakeToCamelCase(val){
  return val.replace(/_\w/g, (txt) => {
    return txt[1].toUpperCase();
  });
}

function snakeToSpasiUpperCase(val){
  return val.replace(/(?:_| |\b)(\w)/g, (txt) => {
    return txt.toUpperCase().replace('_', ' ');
  });
}

function spasiToSnakeCase(val){
  return val.replace(/\s+/g, '_').toLowerCase();
}

function spasiToCamelCase(val){
  return val.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
}

function changeDecimalSeparator(value, from, to){
  let valueString = value.toString();
  let newValue = valueString.replace(from?from:'.', to?to:',');
  return newValue;
}

function camelToSpaceUpperCase(val){
  return val.replace(/([A-Z])/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.slice(1);
  });
}

export default convert;
